import styled from 'styled-components';
import { FInter, FlexBox } from '@brg/ui';
import { LayoutConst } from 'core';

export const TagViewTitle = styled(FInter.MainTitleMediumDiv)`
    color: ${(p) => p.theme.tagView.titleColor};
`;

export const TagWrapper = styled(FlexBox)`
    flex-flow: row;
    justify-content: space-between;
    
    @media(max-width: ${LayoutConst.screen.sm}px) {
        flex-flow: column;
    }
`;

export const TagDescriptionWrapper = styled(FlexBox)`
    max-width: 858px;
    margin-top: 22px;
`;

export const TagImgWrapper = styled.div<{ width: number; height: number }>`
    background-color: white;

    width: ${({ width }) => width}px;
    height: ${({ height }) => height}px;

    @media(max-width: ${LayoutConst.screen.l_12}px) {
       
        margin-left: 24px;
    }

    @media(max-width: ${LayoutConst.screen.sm}px) {

        margin: 24px 0 16px 0;

        .card-img-wrapper {
            height: 100%;
            width: 100%;
            margin-left: 0;
            margin-top: 45px;
        }

        .card-url-text, .card-text-block-wrapper {
            display: none;
            margin: 0;
        }

        #text-second, .card-text-first, .card-museum-text {
            display: none;
        }
    }
`;

export const TagDescription = styled.span`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 28px;
    letter-spacing: -0.02em;
    color: ${({ theme }) => theme.tags.tagEditModal.text.color};

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 17px;
        line-height: 22px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 15px;
        line-height: 20px;
    }

`;
import styled from 'styled-components';
import { FInter, FlexBox } from '@brg/ui';
import { LayoutConst } from 'core';

export const TagViewTitle = styled(FInter.MainTitleMediumDiv)`
    color: ${(p) => p.theme.tagView.titleColor};
`;

export const TagWrapper = styled(FlexBox)`
    flex-flow: row;
    justify-content: space-between;
    
    @media(max-width: ${LayoutConst.screen.sm}px) {
        flex-flow: column;
    }
`;

export const TagDescriptionWrapper = styled(FlexBox)`
    max-width: 858px;
    margin-top: 22px;
`;

export const TagImgWrapper = styled.div<{ width: number; height: number }>`
    background-color: white;

    width: ${({ width }) => width}px;
    height: ${({ height }) => height}px;

    @media(max-width: ${LayoutConst.screen.l_12}px) {
       
        margin-left: 24px;
    }

    @media(max-width: ${LayoutConst.screen.sm}px) {

        margin: 24px 0 16px 0;

        .card-img-wrapper {
            height: 100%;
            width: 100%;
            margin-left: 0;
            margin-top: 45px;
        }

        .card-url-text, .card-text-block-wrapper {
            display: none;
            margin: 0;
        }

        #text-second, .card-text-first, .card-museum-text {
            display: none;
        }
    }
`;

export const TagDescription = styled.span`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 28px;
    letter-spacing: -0.02em;
    color: ${({ theme }) => theme.tags.tagEditModal.text.color};

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 17px;
        line-height: 22px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 15px;
        line-height: 20px;
    }

`;
